export const SuperAdminHomeFeatureKey = 'superadmin-home';
